/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
// BASE Components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
// Material UI Components
import Avatar from "@mui/material/Avatar";
import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import Typography from "@mui/material/Typography";

function RepliesHeader() {

  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          className="mt-0 flex h-40 w-24 items-center justify-center p-0 shadow-none bg-transparent"
        >
          <Avatar
            sx={{
              backgroundColor: "transparent",
              color: '#bdbdbd',
              width: 24,
              height: 24,
            }}
            className="text-16 font-bold"
          >
            <BASESvgIcon size={24}>heroicons-outline:chat-alt-2</BASESvgIcon>
          </Avatar>
        </TimelineDot>

        <TimelineConnector />
      </TimelineSeparator>

      <TimelineContent className="flex items-center pb-32 pt-0 pr-0">
        <Typography className="text-16 font-semibold grow">Replies</Typography>
        <BASESvgIcon
          size={16}
          className="mx-4 flex-none"
          color="action"
        >
          heroicons-outline:chevron-down
        </BASESvgIcon>
      </TimelineContent>
    </TimelineItem>
  );
}

export default RepliesHeader;